import React, { FunctionComponent } from 'react';
import { BrassCalendar } from '../../components';

const DateInputsPlayground: FunctionComponent = () => <BrassCalendar />;

export { DateInputsPlayground };
